import React from 'react'
import PropTypes from 'prop-types'
import injectStyles from 'react-jss'
import TextField from '@material-ui/core/TextField'

import SendIcon from '../../../../Assets/Images/icons/send'
import styles from '../styles'
import ChatFileUpload from '../../ChatFileUpload/container/ChatFileUpload'

const ChatMessageFormView = ({
  onChange,
  onSend,
  onFileUpload,
  messageValue,
  classes,
}) => {
  return (
    <section className={classes.wrapper}>
      <TextField
        multiline
        className={classes.textField}
        onChange={onChange}
        value={messageValue}
        placeholder={'Type a message…'}
        InputProps={{
          disableUnderline: true,
          classes: {
            root: classes.root,
          },
        }}
        onKeyDown={e => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            onSend()
          }
        }}
      />
      <ChatFileUpload onFileUpload={onFileUpload} />
      <button
        className={classes.button}
        onClick={onSend}
        cypress_id={'sendMsgIcon'}
      >
        <SendIcon />
      </button>
    </section>
  )
}

ChatMessageFormView.propTypes = {
  classes: PropTypes.object,
}

export default injectStyles(styles)(ChatMessageFormView)
